import {helpers} from 'vuelidate/lib/validators'

// validator for (positive and negative) decimal values
export const decimal = helpers.regex ('decimal', /^-?[0-9]+(?:\.[0-9]+)?$/)
